/* ==========================================================================
   FS | Sculpta Campaign — shared behaviours
   Scroll reveals, energy scroll-spy, face map, ritual reels, before/after,
   testimonials, video player, sticky buy bar and AJAX add-to-cart.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- global: scroll reveal ---------- */
  function initReveal(root) {
    if (reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-rev]', root).forEach(function (el) {
      if (el.hasAttribute('data-rev-done')) return;
      el.setAttribute('data-rev-done', '');
      var d = el.getAttribute('data-rev-d');
      if (d) el.style.transitionDelay = d + 'ms';
      el.classList.add('sc-rev');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.94) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  /* ---------- global: smooth-scroll anchors ---------- */
  function initScrollLinks(root) {
    $$('[data-scroll]', root).forEach(function (a) {
      if (a.hasAttribute('data-scroll-done')) return;
      a.setAttribute('data-scroll-done', '');
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('data-scroll'));
        if (!target) return;
        e.preventDefault();
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 68,
          behavior: reduce ? 'auto' : 'smooth'
        });
      });
    });
  }

  /* ---------- global: add to cart ---------- */
  var toastTimer;
  function showToast() {
    var toast = $('.fs-sculpta [data-toast]');
    if (!toast) return;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.style.opacity = '';
      toast.style.transform = '';
    }, 2600);
  }

  function refreshCartBubble() {
    try {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-icon-bubble'];
          if (!html) return;
          var holder = document.getElementById('cart-icon-bubble');
          if (holder) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var inner = tmp.querySelector('.shopify-section') || tmp;
            holder.innerHTML = inner.innerHTML;
          }
        })
        .catch(function () {});
    } catch (e) { /* noop */ }
  }

  /* Switch a sticky-bar button into "Checkout" mode once the product is in the basket. */
  function markCheckout(btn) {
    if (!btn || btn.hasAttribute('data-checkout-mode')) return;
    btn.setAttribute('data-checkout-mode', '');
    var label = btn.querySelector('[data-btn-label]');
    if (label) label.textContent = btn.getAttribute('data-checkout-label') || 'Checkout';
  }

  function markStickyCheckout(except) {
    $$('.fs-sculpta [data-sticky] [data-add]').forEach(function (b) {
      if (b !== except) markCheckout(b);
    });
  }

  /* On load: if the buy-bar product is already in the basket, show Checkout straight away. */
  var checkoutChecked = false;
  function initCheckoutState() {
    if (checkoutChecked) return;
    var stickyBtn = $('.fs-sculpta [data-sticky] [data-add][data-variant-id]');
    if (!stickyBtn) return;
    checkoutChecked = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var vid = Number(stickyBtn.getAttribute('data-variant-id'));
        var inCart = (cart.items || []).some(function (it) { return it.variant_id === vid; });
        if (inCart) markStickyCheckout(null);
      })
      .catch(function () {});
  }

  function initAddToCart(root) {
    $$('[data-add]', root).forEach(function (btn) {
      if (btn.hasAttribute('data-add-done')) return;
      btn.setAttribute('data-add-done', '');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('data-checkout-mode')) {
          window.location.href = '/checkout';
          return;
        }
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          var url = btn.getAttribute('data-product-url');
          if (url) window.location.href = url;
          return;
        }
        if (btn._busy) return;
        btn._busy = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          showToast();
          refreshCartBubble();
          document.dispatchEvent(new CustomEvent('fs-sculpta:added'));
          var isSticky = !!btn.closest('[data-sticky]');
          markStickyCheckout(isSticky ? btn : null);
          var label = btn.querySelector('[data-btn-label]');
          if (label) {
            var w = btn.offsetWidth;
            btn.style.minWidth = w + 'px';
            var old = label.textContent;
            label.textContent = 'Added ✓';
            setTimeout(function () {
              btn._busy = false;
              if (isSticky) { markCheckout(btn); } else { label.textContent = old; }
            }, 1200);
          } else {
            btn._busy = false;
            if (isSticky) markCheckout(btn);
          }
        }).catch(function () {
          btn._busy = false;
          var url = btn.getAttribute('data-product-url');
          if (url) window.location.href = url;
        });
      });
    });
  }

  /* ---------- hide Gorgias chat on the campaign template ---------- */
  var gorgiasHidden = false;
  function initGorgiasHide() {
    if (gorgiasHidden) return;
    if (!document.body.classList.contains('template-page-sculpta-campaign')) return;
    gorgiasHidden = true;
    var hide = function () {
      var el = document.getElementById('gorgias-chat-container');
      if (el && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
    };
    hide();
    try {
      new MutationObserver(hide).observe(document.body, { childList: true });
    } catch (e) { /* noop */ }
    var tryApi = function (attempt) {
      try {
        if (window.GorgiasChat && typeof window.GorgiasChat.hideWidget === 'function') {
          window.GorgiasChat.hideWidget();
          return;
        }
      } catch (e) { /* noop */ }
      if (attempt < 20) setTimeout(function () { tryApi(attempt + 1); }, 500);
    };
    tryApi(0);
  }

  /* ---------- sticky buy bar ---------- */
  function initStickyBar(root) {
    var sticky = $('[data-sticky]', root);
    if (!sticky || sticky.hasAttribute('data-sticky-done')) return;
    sticky.setAttribute('data-sticky-done', '');
    var onScroll = function () {
      var hero = document.querySelector('.fs-sculpta [data-hero]');
      var threshold = hero ? hero.offsetTop + hero.offsetHeight * 0.66 : 520;
      sticky.style.transform = window.scrollY > threshold ? 'translateY(0)' : 'translateY(120%)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- tech (energy) cards ---------- */
  function initTechCards(root) {
    var cards = $$('[data-tech]', root);
    cards.forEach(function (card) {
      if (card.hasAttribute('data-tech-done')) return;
      card.setAttribute('data-tech-done', '');
      card.addEventListener('click', function () {
        var open = card.hasAttribute('data-open');
        cards.forEach(function (c) { if (c !== card) c.removeAttribute('data-open'); });
        if (open) { card.removeAttribute('data-open'); } else { card.setAttribute('data-open', ''); }
      });
    });
  }

  /* ---------- S3 pinned horizontal scroll-spy ---------- */
  function initEnergiesPin(root) {
    var outer = $('.fss-s3-outer', root);
    var pin = $('.fss-s3-pin', root);
    var track = $('.fss-s3-track', root);
    if (!outer || !pin || !track || outer.hasAttribute('data-s3-done')) return;
    outer.setAttribute('data-s3-done', '');
    var cards = $$('[data-tech]', track);
    var spyFill = $('[data-spy-fill]', root);
    var spyLabel = $('[data-spy-label]', root);
    var spyCount = $('[data-spy-count]', root);
    var names = cards.map(function (c) { return c.getAttribute('data-tech-name') || ''; });

    var update = function () {
      if (!window.matchMedia('(min-width: 901px)').matches) {
        track.style.transform = '';
        cards.forEach(function (c) { c.setAttribute('data-cur', ''); });
        return;
      }
      var total = outer.offsetHeight - pin.offsetHeight;
      var p = Math.min(Math.max(-outer.getBoundingClientRect().top / (total || 1), 0), 1);
      var maxX = Math.max(0, track.scrollWidth - pin.clientWidth);
      track.style.transform = 'translate3d(' + (-p * maxX).toFixed(1) + 'px,0,0)';
      var ci = Math.max(0, Math.min(cards.length - 1, Math.floor(p * cards.length - 1e-6)));
      cards.forEach(function (c, i) { c.toggleAttribute('data-cur', i === ci); });
      if (spyFill) spyFill.style.width = (p * 100) + '%';
      if (spyLabel) spyLabel.textContent = names[ci] || names[0] || '';
      if (spyCount) spyCount.textContent = '0' + (ci + 1) + ' / 0' + cards.length;
    };
    var layout = function () {
      if (!window.matchMedia('(min-width: 901px)').matches) { outer.style.height = ''; return; }
      var maxX = Math.max(0, track.scrollWidth - pin.clientWidth);
      outer.style.height = (window.innerHeight + maxX * 4.5) + 'px';
    };
    var all = function () { layout(); update(); };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', all, { passive: true });
    window.addEventListener('load', all);
    requestAnimationFrame(all);
    setTimeout(all, 400);
    setTimeout(all, 1200);
  }

  /* ---------- face map / micro moves ---------- */
  function initFaceMap(root) {
    var grid = $('.fss-s5-grid', root);
    if (!grid || grid.hasAttribute('data-s5-done')) return;
    grid.setAttribute('data-s5-done', '');
    var moves = $$('[data-move]', root);
    var hots = $$('[data-hot]', root);
    var jsonEl = $('[data-moves-json]', root);
    if (!moves.length || !jsonEl) return;
    var data = [];
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { /* noop */ }
    var mTitle = $('[data-move-title]', root);
    var mDesc = $('[data-move-desc]', root);
    var mNum = $('[data-move-num]', root);
    var mRegion = $('[data-move-region]', root);
    var select = function (i) {
      moves.forEach(function (m, j) { m.setAttribute('aria-selected', String(j === i)); });
      hots.forEach(function (h, j) { h.toggleAttribute('data-active', j === i); });
      var d = data[i] || {};
      if (mTitle) mTitle.textContent = d.t || '';
      if (mDesc) mDesc.textContent = d.d || '';
      if (mNum) mNum.textContent = String(i + 1).padStart(2, '0');
      if (mRegion) mRegion.textContent = d.r || '';
    };
    moves.forEach(function (m, i) { m.addEventListener('click', function () { select(i); }); });
    hots.forEach(function (h, i) { h.addEventListener('click', function () { select(i); }); });
    select(0);
  }

  /* ---------- ritual reels ---------- */
  function initRituals(root) {
    var cards = $$('[data-ritual]', root);
    cards.forEach(function (card) {
      if (card.hasAttribute('data-ritual-done')) return;
      card.setAttribute('data-ritual-done', '');
      var vid = card.querySelector('video');
      if (!vid) return;
      $$('[data-ritual-play]', card).forEach(function (play) {
        play.addEventListener('click', function (e) {
          e.preventDefault();
          if (vid.paused) {
            cards.forEach(function (c) {
              if (c !== card) {
                var v = c.querySelector('video');
                if (v) v.pause();
                c.removeAttribute('data-playing');
              }
            });
            card._userPaused = false;
            card.setAttribute('data-playing', '');
            vid.play().catch(function () {});
          } else {
            card._userPaused = true;
            vid.pause();
            card.removeAttribute('data-playing');
          }
        });
      });
      vid.addEventListener('ended', function () { card.removeAttribute('data-playing'); });
    });

    /* Autoplay the first ritual reel while it is in view (muted; skipped when
       the user paused it themselves, another reel is playing, or reduced motion). */
    var first = cards[0];
    if (first && !first.hasAttribute('data-ritual-auto')) {
      first.setAttribute('data-ritual-auto', '');
      var firstVid = first.querySelector('video');
      if (firstVid && !reduce) {
        var autoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (first._userPaused) return;
              var otherPlaying = cards.some(function (c) { return c !== first && c.hasAttribute('data-playing'); });
              if (otherPlaying) return;
              firstVid.muted = true;
              first.setAttribute('data-playing', '');
              firstVid.play().catch(function () {});
            } else if (!first._userPaused) {
              firstVid.pause();
              first.removeAttribute('data-playing');
            }
          });
        }, { threshold: 0.5 });
        autoIo.observe(first);
      }
    }
  }

  /* ---------- before / after slider ---------- */
  function initBeforeAfter(root) {
    $$('[data-ba]', root).forEach(function (ba) {
      if (ba.hasAttribute('data-ba-done')) return;
      ba.setAttribute('data-ba-done', '');
      var top = $('[data-ba-top]', ba);
      var handle = $('[data-ba-handle]', ba);
      if (!top || !handle) return;
      var drag = false;
      var set = function (p) {
        p = Math.max(0, Math.min(100, p));
        top.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        handle.style.left = p + '%';
      };
      var fromX = function (x) {
        var r = ba.getBoundingClientRect();
        set(((x - r.left) / r.width) * 100);
      };
      /* One-time hint sweep when the slider first scrolls into view, so
         visitors can see the handle is draggable. Cancelled by any touch. */
      var hintId = null;
      var hintDone = false;
      var cancelHint = function () {
        hintDone = true;
        if (hintId) { cancelAnimationFrame(hintId); hintId = null; }
      };
      var runHint = function () {
        if (hintDone || reduce) return;
        hintDone = true;
        var frames = [
          { t: 0, p: 50 }, { t: 900, p: 68 }, { t: 2100, p: 32 }, { t: 3000, p: 50 }
        ];
        var startTs = null;
        var ease = function (x) { return 0.5 - Math.cos(Math.PI * x) / 2; };
        var step = function (ts) {
          if (startTs === null) startTs = ts;
          var el = ts - startTs;
          var i = 1;
          while (i < frames.length && frames[i].t < el) i++;
          if (i >= frames.length) { set(50); hintId = null; return; }
          var a = frames[i - 1];
          var b = frames[i];
          set(a.p + (b.p - a.p) * ease((el - a.t) / (b.t - a.t)));
          hintId = requestAnimationFrame(step);
        };
        hintId = requestAnimationFrame(step);
      };
      var hintIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { runHint(); hintIo.unobserve(ba); }
        });
      }, { threshold: 0.55 });
      hintIo.observe(ba);

      ba.addEventListener('dragstart', function (e) { e.preventDefault(); });
      ba.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        cancelHint();
        drag = true;
        try { ba.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        fromX(e.clientX);
      });
      ba.addEventListener('pointermove', function (e) { if (drag) fromX(e.clientX); });
      ba.addEventListener('pointerup', function () { drag = false; });
      ba.addEventListener('pointercancel', function () { drag = false; });
      ba.addEventListener('lostpointercapture', function () { drag = false; });
      set(50);
    });
  }

  /* ---------- testimonials ---------- */
  function initTestimonials(root) {
    $$('[data-testi]', root).forEach(function (group) {
      if (group.hasAttribute('data-testi-done')) return;
      group.setAttribute('data-testi-done', '');
      var slides = $$('[data-testi-slide]', group);
      var dots = $$('[data-testi-dot]', group);
      if (!slides.length) return;
      var ti = 0;
      var auto;
      slides.forEach(function (s, j) {
        s.style.position = j === 0 ? 'relative' : 'absolute';
        s.style.inset = '0';
      });
      var show = function (i) {
        ti = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          s.style.opacity = j === ti ? '1' : '0';
          s.style.pointerEvents = j === ti ? '' : 'none';
          s.style.position = j === ti ? 'relative' : 'absolute';
        });
        dots.forEach(function (d, j) { d.toggleAttribute('data-active', j === ti); });
      };
      $$('[data-testi-prev]', group).forEach(function (b) { b.addEventListener('click', function () { show(ti - 1); }); });
      $$('[data-testi-next]', group).forEach(function (b) { b.addEventListener('click', function () { show(ti + 1); }); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
      show(0);
      var start = function () { if (!reduce) auto = setInterval(function () { show(ti + 1); }, 6500); };
      var stop = function () { clearInterval(auto); };
      group.addEventListener('pointerenter', stop);
      group.addEventListener('pointerleave', start);
      start();
    });
  }

  /* ---------- branded video player ---------- */
  function initPlayer(root) {
    $$('[data-player]', root).forEach(function (vp) {
      if (vp.hasAttribute('data-player-done')) return;
      vp.setAttribute('data-player-done', '');
      var v = $('video', vp);
      if (!v) return;
      var track = $('[data-vp-track]', vp);
      var fill = $('[data-vp-fill]', vp);
      var cur = $('[data-vp-cur]', vp);
      var dur = $('[data-vp-dur]', vp);
      var mute = $('[data-vp-mute]', vp);
      var cc = $('[data-vp-cc]', vp);
      var fs = $('[data-vp-fs]', vp);
      var cap = $('[data-vp-cap]', vp);
      var fmt = function (s) {
        s = Math.floor(s || 0);
        return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
      };
      var toggle = function () { if (v.paused) { v.play().catch(function () {}); } else { v.pause(); } };
      $$('[data-vp-play]', vp).forEach(function (b) { b.addEventListener('click', toggle); });
      v.addEventListener('play', function () { vp.setAttribute('data-playing', ''); });
      v.addEventListener('pause', function () { vp.removeAttribute('data-playing'); });
      v.addEventListener('timeupdate', function () {
        if (v.duration && fill) {
          fill.style.width = (v.currentTime / v.duration * 100) + '%';
          if (cur) cur.textContent = fmt(v.currentTime);
        }
      });
      v.addEventListener('loadedmetadata', function () { if (dur) dur.textContent = fmt(v.duration); });
      if (track) {
        track.addEventListener('pointerdown', function (e) {
          var r = track.getBoundingClientRect();
          if (v.duration) v.currentTime = ((e.clientX - r.left) / r.width) * v.duration;
        });
      }
      if (mute) mute.addEventListener('click', function () { v.muted = !v.muted; mute.toggleAttribute('data-off', v.muted); });
      if (cc) cc.addEventListener('click', function () { var on = cc.toggleAttribute('data-on'); if (cap) cap.style.display = on ? 'block' : 'none'; });
      if (fs) {
        fs.addEventListener('click', function () {
          if (document.fullscreenElement) { document.exitFullscreen(); } else if (vp.requestFullscreen) { vp.requestFullscreen(); }
        });
      }
      v.muted = true;
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (!reduce) v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.45 });
      pio.observe(vp);
    });
  }

  function initAll() {
    initGorgiasHide();
    initCheckoutState();
    $$('.fs-sculpta').forEach(function (root) {
      initReveal(root);
      initScrollLinks(root);
      initAddToCart(root);
      initStickyBar(root);
      initTechCards(root);
      initEnergiesPin(root);
      initFaceMap(root);
      initRituals(root);
      initBeforeAfter(root);
      initTestimonials(root);
      initPlayer(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
